import type { TFunction } from "i18next";

/**
 * What the bell's number is made of, in words — "3 requests waiting · 1 unread notification" — naming only the parts
 * that aren't zero, and saying so when both are. The bell's tooltip, and (after "Updates:") its accessible name.
 */
export const bellBadgeSummary = (requestsCount: number, unreadNotificationsCount: number, t: TFunction): string => {
	const parts = [
		...(requestsCount > 0 ? [t("scheduleChanges.panel.bellTooltip.requests", { count: requestsCount })] : []),
		...(unreadNotificationsCount > 0 ? [t("scheduleChanges.panel.unreadNotifications", { count: unreadNotificationsCount })] : []),
	];
	return parts.length === 0 ? t("scheduleChanges.panel.bellTooltip.none") : parts.join(" · ");
};
